import { gql } from '@apollo/client';

const WarrantyErrorInfo = gql`
  fragment WarrantyErrorInfo on WarrantyError {
    id
    name
    description
    createdAt
    updatedAt
  }
`;

export default WarrantyErrorInfo;
